import React from 'react';
export var ResponsiveContext = React.createContext(undefined);